type IconProps = {
  children: React.ReactNode;
};

export function Icon({ children }: IconProps) {
  return <span style={{ display: 'flex' }}>{children}</span>;
}
